import React, {useEffect} from 'react'
import Banner from '../../components/Banner/Banner'
import Footer from '../../components/Footer/Footer'
import Navbar from '../../components/Navbar/Navbar'
import TopBar from '../../components/TopBar/TopBar'
import NewsImage from "../../assets/NewsBanner.jpeg"
import NewsSection from '../../components/NewsSection/NewsSection'
import { Link, useLocation } from 'react-router-dom'
import { BsWhatsapp } from 'react-icons/bs'

const NewsPage = () => {
  const location = useLocation()
  // Scroll to the top when the page is mounted or the location changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div>
       
        <Banner underline="true" title="News & Events" subtitle="" image={NewsImage} />
        <NewsSection />
        
        <Footer />
    </div>
  )
}

export default NewsPage